import React from 'react'
import { FetalDiagnosesContent } from '~/components/fetalDiagnoses/FetalDiagnosisContent'
import { withDashboardLoader } from '~/components/shared'
import { FetalDiagnosesProvider } from '~/context'
import { useDocumentTitle } from '~/hooks'
import { message } from '~/services'

const FetalDiagnosesPage = (): JSX.Element => {
  useDocumentTitle(message('titles.fetal_diagnoses'))

  return (
    <FetalDiagnosesProvider>
      <FetalDiagnosesContent />
    </FetalDiagnosesProvider>
  )
}

export const FetalDiagnoses = withDashboardLoader(FetalDiagnosesPage)
